export function OutlineSquareDashedIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.02441 9.5918V4.5918C3.02441 3.4918 3.92441 2.5918 5.02441 2.5918H10.0244"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M10.0244 20.5918H5.02441C3.92441 20.5918 3.02441 19.6918 3.02441 18.5918V13.5918"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M14.0244 2.5918H19.0244C20.1244 2.5918 21.0244 3.4918 21.0244 4.5918V9.5918"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M21.0244 13.5918V18.5918C21.0244 19.6918 20.1244 20.5918 19.0244 20.5918H14.0244"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
